// extracted by mini-css-extract-plugin
export default {"timer":"DonationTimer_timer__vTJp-","background":"DonationTimer_background__yuymC","text":"DonationTimer_text__KJUbe"};